var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.isRPTradeModule)?_c('RPTrage'):_vm._e(),(_vm.isReportModule || _vm.isONEProject)?_c('Reports'):_vm._e(),(_vm.isTicketProject)?_c('Tickets'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }